import { hasConsent, onConsentChange } from "../cookiebar/consent.js";

const MARKETING = "marketing";

// The content URLs already carry a query string (?rel=0&controls=0&…), so the
// separator has to be chosen rather than always appending "?autoplay=1".
function withAutoplay(url) {
  const separator = url.indexOf("?") === -1 ? "?" : "&";

  return url + separator + "autoplay=1";
}

// Defensive: at least one embed URL in the content has a stray quote on the
// end, which would otherwise produce a broken iframe src.
function cleanUrl(url) {
  return url.trim().replace(/['"]+$/, "");
}

export default function videoModal() {
  const playButtons = [].slice.call(document.querySelectorAll(".play-button"));
  const entries = [];

  playButtons.forEach(playButton => {
    const modal = document.querySelector(
      `.video-modal[data-id="${playButton.dataset.id}"]`
    );

    if (!modal || !playButton.dataset.video) {
      return;
    }

    const embedUrl = cleanUrl(playButton.dataset.video);
    const iframe = modal.querySelector("iframe");
    const closeButton = modal.querySelector(".video-modal__close");
    const consentPanel = modal.querySelector(".video-modal__consent");

    if (!iframe || !closeButton) {
      return;
    }

    function loadVideo() {
      if (consentPanel) {
        consentPanel.hidden = true;
      }

      iframe.hidden = false;
      iframe.src = withAutoplay(embedUrl);
    }

    function showConsentPanel() {
      if (consentPanel) {
        consentPanel.hidden = false;
      }

      iframe.hidden = true;
      iframe.src = "about:blank";
    }

    function openModal() {
      modal.classList.add("video-modal--visible");
      modal.setAttribute("aria-hidden", "false");

      if (hasConsent(MARKETING)) {
        loadVideo();
      } else {
        showConsentPanel();
      }
    }

    function closeModal() {
      modal.classList.remove("video-modal--visible");
      modal.setAttribute("aria-hidden", "true");
      iframe.src = "about:blank";
    }

    playButton.addEventListener("click", openModal);
    closeButton.addEventListener("click", closeModal);

    modal.addEventListener("click", event => {
      if (event.target === modal) {
        closeModal();
      }
    });

    entries.push({ modal, iframe, loadVideo, closeModal });
  });

  onConsentChange(() => {
    const isAllowed = hasConsent(MARKETING);

    entries.forEach(entry => {
      const isOpen = entry.modal.classList.contains("video-modal--visible");

      if (isAllowed) {
        // Pick up where the visitor left off. They pressed play, were told the
        // video was blocked, and have just allowed marketing — so start it
        // rather than making them find the play button again. `iframe.hidden`
        // means the notice is still showing, which also stops an already
        // playing video from restarting when an unrelated category is toggled.
        if (isOpen && entry.iframe.hidden) {
          entry.loadVideo();
        }
      } else {
        // Withdrawal has to take effect straight away, so no already-loaded
        // player keeps talking to Google.
        entry.closeModal();
      }
    });
  });
}
